import { render, staticRenderFns } from "./unSold.vue?vue&type=template&id=48721eae&scoped=true&"
import script from "./unSold.vue?vue&type=script&lang=js&"
export * from "./unSold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48721eae",
  null
  
)

export default component.exports